<template>
  <div class="health-page">
    <div class="health-page-status">
      <div
        v-for="(element, index) in data"
        :key="element.id"
        :class="`health-element health-element-${index + 1}`">

        <div
          class="health-icon pointer"
          @click="$emit('show', element.id)">
          <img :src="element.image" width="100%" :alt="element.name"/>
        </div>

        <div :class="`border health-item health-item-${index}`">
          <div class="border-bottom py-1 px-2 font-weight-bold text-primary">
            {{element.name}}
          </div>

          <div
            v-for="item in element.items"
            :key="item.id"
            :class="`cursor-pointer py-1 px-2 health-status-item health-status-item-${item.value}`"
            @click="itemId = itemId === item.id ? 'null' : item.id">
            {{item.name}}

            <div
              v-if="userCanEdit && itemId === item.id"
              class="health-item-chooser border shadow">
              <div class="py-1 px-1 font-weight-bold text-primary">
                {{item.name}}
              </div>

              <div
                v-for="choice in chooses"
                :key="`${item.id}-${choice.value}`"
                :class="`cursor-pointer py-1 px-1 health-status-item health-status-item-${choice.value}`"
                @click="setStatus(item.id, choice.value)">
                {{choice.title}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="health-human">
        <img :src="imageMan" width="100%" alt="man"/>
      </div>
    </div>
  </div>
</template>

<script>
import ImageMan from '../../../assets/img/status/man.png';
import ImageBrain from '../../../assets/img/status/brain.png';
import ImageStress from '../../../assets/img/status/stress.png';
import ImageEnergy from '../../../assets/img/status/energy.png';
import ImageMetabolism from '../../../assets/img/status/metabolism.png';
import ImageVitamins from '../../../assets/img/status/vitamins.png';
import ImageDigestion from '../../../assets/img/status/digestion.png';
import ImageSystems from '../../../assets/img/status/systems.png';
import ImageAntiage from '../../../assets/img/status/antiage.png';

export default {
  name: 'status',

  props: ['client', 'status', 'elements', 'userCanEdit'],

  data() {
    return {
      itemId: null,
      imageMan: ImageMan,
    };
  },

  computed: {
    chooses() {
      return [
        { value: 1, title: 'Болезнь' },
        { value: 3, title: 'Отклонение' },
        { value: 5, title: 'Норма' },
      ];
    },

    data() {
      const elementsData = [
        ['Мозг', ImageBrain, 'brain'],
        ['Стресс', ImageStress, 'stress'],
        ['Энергия', ImageEnergy, 'energy'],
        ['Метаболизм', ImageMetabolism, 'metabolism'],
        ['Витамины и нутриенты', ImageVitamins, 'vitamins'],
        ['Пищеварение', ImageDigestion, 'digestion'],
        ['Органы и системы', ImageSystems, 'systems'],
        ['Anti-Age', ImageAntiage, 'antiage'],
      ];
      const elements = this.elements.map(({id, name, sort, parent}) => {
        const result = {id, name, sort, parent, items: [], alias: '', value: '', image: ''};
        const data = elementsData.find(([title]) => title === name);

        if (typeof data !== 'undefined') {
          result.image = data[1];
          result.alias = data[2];
        }

        if (typeof this.status[id] !== 'undefined') {
          result.value = this.status[id];
        }

        return result;
      });

      elements.sort((a, b) => a.sort - b.sort);

      elements.forEach(element => {
        if (typeof element.parent === 'string') {
          const parent = elements.find(e => e.id === element.parent);

          if (typeof parent !== 'undefined') {
            parent.items.push(element);
          }
        }
      });

      return elements.filter(element => element.parent === null);
    },
  },

  methods: {
    async setStatus(health, value) {
      if (!this.userCanEdit) {
        return;
      }

      this.$emit('update', {health, value});
    },
  },
};
</script>
